import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-10 md:py-16 bg-gradient-to-br from-brand-orange/10 to-brand-cream" data-id="element-123">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-10 rounded-[2rem] shadow-xl border border-orange-100" data-id="element-125">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-5" data-id="element-126">
            The 7-Day Shift 🌅
          </h2>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-5 italic" data-id="element-127">
            "Imagine landing at your destination without feeling like you've
            just run a marathon. Instead of arriving exhausted and apologetic,
            you walk off the plane with a happy child and the confidence that
            you can handle any trip, anywhere in the world."
          </p>

          <div className="inline-flex items-center gap-2 text-brand-orange font-bold text-lg" data-id="element-128">
            <span data-id="element-129">★★★★★</span>
            <span className="text-brand-dark" data-id="element-130">
              The new standard for family travel
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}